<template>
  <div>
    <Header></Header>
    <div class="wrapper">
      <div class="top">
        <p class="col-12 top-nav text-left"><span class="index">首页</span><span>&gt;</span><span class="second">资讯动态</span></p>
      </div>
      <div class="main row justify-content-between">
        <div class="col-md-8 col-11">
          <NewsDetail1 v-show="id == '1'"></NewsDetail1>
          <NewsDetail2 v-show="id == '2'"></NewsDetail2>
          <NewsDetail3 v-show="id == '3'"></NewsDetail3>
          <NewsDetail4 v-show="id == '4'"></NewsDetail4>
          <NewsDetail5 v-show="id == '5'"></NewsDetail5>
          <NewsDetail6 v-show="id == '6'"></NewsDetail6>
          <NewsDetail7 v-show="id == '7'"></NewsDetail7>
          <NewsDetail8 v-show="id == '8'"></NewsDetail8>
          <NewsDetail9 v-show="id == '9'"></NewsDetail9>
          <NewsDetail10 v-show="id == '10'"></NewsDetail10>
        </div>

        <div class="col-md-3 text-left asideList">
          <p class="subtitle">热门资讯</p>
          <a href="javascript:void(0)" @click="toLink(1)"><p class="link-block" v-bind:class="{active: id == 1}"><span>年中复盘，继往开来丨及时雨小贷半年度工作总结</span></p></a>
          <a href="javascript:void(0)" @click="toLink(9)"><p class="link-block" v-bind:class="{active: id == 9}"><span>及时雨小贷创始人宋梅受邀出席第七届“在沪女企业家峰会”！</span></p></a>
          <a href="javascript:void(0)" @click="toLink(10)"><p class="link-block" v-bind:class="{active: id == 10}"><span>全员齐动，稳中求进——2019及时雨小贷团建</span></p></a>
          <a href="javascript:void(0)" @click="toLink(8)"><p class="link-block" v-bind:class="{active: id == 8}"><span>及时雨小贷宋梅荣获“2015中国小微金融年度人物”称号</span></p></a>
          <a href="javascript:void(0)" @click="toLink(2)"><p class="link-block" v-bind:class="{active: id == 2}"><span>周年庆丨六年风雨同行 共谱美好篇章</span></p></a>
          <a href="javascript:void(0)" @click="toLink(3)"><p class="link-block" v-bind:class="{active: id == 3}"><span>喜报！上海及时雨小贷斩获“全国优秀小贷”荣誉</span></p></a>
          <a href="javascript:void(0)" @click="toLink(5)"><p class="link-block" v-bind:class="{active: id == 5}"><span>重磅：上海小贷行业完成首单同业拆借</span></p></a>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import $ from 'jquery'
  import Header from './Header'
  import Footer from './Footer'
  import NewsDetail1 from './NewsDetail1'
  import NewsDetail2 from './NewsDetail2'
  import NewsDetail3 from './NewsDetail3'
  import NewsDetail4 from './NewsDetail4'
  import NewsDetail5 from './NewsDetail5'
  import NewsDetail6 from './NewsDetail6'
  import NewsDetail7 from './NewsDetail7'
  import NewsDetail8 from './NewsDetail8'
  import NewsDetail9 from './NewsDetail9'
  import NewsDetail10 from './NewsDetail10'

  export default {
    name: "NewsDetail",
    components:{Header,Footer,NewsDetail1,NewsDetail2,NewsDetail3,NewsDetail4,NewsDetail5,NewsDetail6,NewsDetail7,NewsDetail8,NewsDetail9,NewsDetail10},
    data(){
      return {
        id:''
      }
    },
    created() {
      // let u = window.location.href.split('?')[1].substr(3,1);
      let u = this.$route.query.id;
      this.id = u;
    },
    mounted() {
      $('html,body').animate({
          scrollTop: 0
        },
        10);
    },
    methods: {
      toLink: function(id) {
        this.id = id;
        window.location.href = '/#/NewsDetail?id=' + id;
        $('html,body').animate({
            scrollTop: 0
          },
          350);
      }
    }
  }
</script>

<style scoped lang="less">
  p{margin:0;}
  a:hover{text-decoration: none;}

  //pc、laptop
  @media screen and (min-width: 769px) {
    .top,.main{
      width:1300px !important;
    }
  }

  //phone
  @media screen and (max-width: 768px) {
    .wrapper{
      padding-top:90px;
    }
    .asideList{
      display: none;
    }
    .top{
      font-size: 26px;
    }
  }

  .top{
    margin: 60px auto 48px;
    padding-left:50px;

    .top-nav{
      /*font-size:20px;*/
      margin-bottom:48px;

      .index{
        margin-right:10px;
        color:#01A494;
      }
      .second{
        margin-left:10px;
      }
    }
  }
  .main{
    margin:0 auto;
    padding-left:50px;
    padding-bottom:190px;

    //左边
    .title{font-size:36px;font-weight:bold;}
    .desc{
      font-size:14px;
      margin-bottom:50px;
      line-height: 42px;

      .author{
        color:#006D73;
      }
    }
    .main-content{
      .normal,.bold{
        margin-bottom:30px;
      }
      .bold{
        font-size:22px;
        font-weight:bold;
        /*height:16px;*/
        span{
          /*background:linear-gradient(to bottom, transparent 0%, rgba(0,109,115,0.2) 50%, rgba(0,109,115,0.2) 100%);*/
        }

      }
    }

    //右边
    .subtitle{
      font-size: 20px;
      color: #787B80;
      margin-bottom:29px;
    }
    .link-block{
      width:100%;
      height:80px;
      border-bottom:1px solid #eee;
      padding:0 17px;
      display: table;
      color:#35383D;
      /*font-weight:bold;*/

      span{
        display: table-cell;
        vertical-align: middle;
      }

      &.active{
        background:#008B7D;
        color:#fff;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/NewsDetail.vue